<template>
  <div class="ml-group">
    <div class="d-flex align-items-center justify-content-between mt-2">
      <div class="ml-group__header">
        <div class="ml-group__title" v-html="title"></div>
        <div class="ml-group__subtitle" v-html="subtitle"></div>
      </div>

      <div class="ml-group__legend">
        <slot name="legend"></slot>
      </div>
    </div>

    <slot name="content"></slot>
  </div>
</template>

<script>
  export default {
    name: 'Group',
    props: {
      subtitle: {
        type: String,
        default: ''
      },
      title: {
        required: true
      }
    }
  }
</script>

<style lang="scss">
  @import "../styles/theme.scss";
</style>



// WEBPACK FOOTER //
// src/components/Group.vue